<div ngbDropdown class="technician-dropdown" [autoClose]="'outside'">
  <button
    type="button"
    class="technician-select"
    ngbDropdownToggle
    [disabled]="disabled || isLoading">
    <span class="technician-select-label">
      @if (showCountBadge) {
        <span class="technician-count__segments">{{ selectedCount }}</span>
      }
      <span
        class="technician-select-text"
        [class.technician-placeholder]="selectedTechnicianIds.length === 0">
        {{ label }}
      </span>
    </span>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 6L8 10L12 6" stroke="#9FA1A4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <div ngbDropdownMenu class="technician-dropdown-menu">
    @if (isLoading) {
      <div class="technician-state">
        <span class="spinner-border spinner-border-sm"></span>
      </div>
    } @else if (technicians.length === 0) {
      <div class="technician-state">{{ 'workOrder.technicianDropdown.noTechniciansFound' | transloco }}</div>
    } @else {
      @for (technician of technicians; track technician.technicianId) {
        <button
          ngbDropdownItem
          type="button"
          class="technician-option"
          [class.selected]="isSelected(technician.technicianId)"
          (click)="toggleTechnician(technician)">
          <input
            type="checkbox"
            class="technician-checkbox"
            tabindex="-1"
            [checked]="isSelected(technician.technicianId)"
            (click)="onCheckboxClick($event, technician)" />
          <span>{{ technician.technicianName }}</span>
        </button>
      }
    }
  </div>
</div>
